<div class="content">
  <div *ngIf="uploadVisible || helpVisible" class="blocker">
    <div *ngIf="uploadVisible" class="popup">
      <textarea class="uploadtext" (change)="setUploadData($event)" [(ngModel)]="uploadData"
                placeholder="Paste the text from the TradeSkillExporter addon here"></textarea>
      <br/>
      <table width="100%">
        <tr>
          <td style="text-align: right">
            <span class="message-error-{{error}}">{{message != null ? message : '&nbsp;'}}</span>
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <a class="button" (click)="closeUpload()">Close</a>
            <a class="button" (click)="upload()">Upload</a>
          </td>
        </tr>
      </table>
    </div>
    <div *ngIf="helpVisible" class="popup">
      <div class="helptext">
        <br/>
        <b>To search for a recipe and the individuals who have it</b>
        <ul>
          <li>Use the filters above the table to narrow the search.</li>
        </ul>
        <br/>
        <b>To upload your tradeskills</b>
        <ul>
          <li>Download the <b>TradeSkillExporter</b> addon from Curse/Twitch or press the <b>Download Addon</b> button above.
          </li>
          <li>Open a tradeskill window in World of Warcraft (tailoring, enchanting, but also cooking, first-aid, poison).
          </li>
          <li>Type <b>/tse</b> and a window that contains all recipes you know opens. Press <b>CTRL-C</b> to copy the
            text.
          </li>
          <li>Press the <b>Upload Tradeskill</b> button above and <b>CTRL-V</b> the text from the addon into the textarea.
          </li>
          <li>Press the <b>Upload</b> button to upload the tradeskills.</li>
        </ul>
        <br/>
        <b>To delete all your tradeskills</b>
        <ul>
          <li>Close all tradeskill windows in World of Warcraft.
          </li>
          <li>Type <b>/tse</b> and a window that contains no recipes opens. Press <b>CTRL-C</b> to copy the text.
          </li>
          <li>Press the <b>Upload Tradeskill</b> button above and <b>CTRL-V</b> the text from the addon into the textarea.
          </li>
          <li>Press the <b>Upload</b> button to delete the tradeskills.</li>
        </ul>
        <br/>
        <b>Save Filter</b>
        <ul>
          <li>
            This button allows you to save the current filter settings. This allows you for example to only see your own server
            or guild when you open the website. The saved filter settings can be changed at any time.
          </li>
        </ul>
      </div>
      <br/>
      <table width="100%">
        <tr>
          <td style="text-align: right">
            <a class="button" (click)="closeHelp()">Close</a>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div [class]="'logo logo-' + version"></div>
  <div class="buttonbar">
    <a class="button help" (click)="openHelp();" [title]="helpTooptip">Help</a>
    <a class="button download" (click)="downloadAddon();" [title]="downloadAddonTooptip">Download Addon</a>
    <a class="button upload" (click)="openUpload();" [title]="uploadTooptip">Upload Tradeskill</a>
    <a class="button export" (click)="exportCsv();" [title]="exportCsvTooptip">Export CSV</a>
    <a class="button savefilter" (click)="saveFilter();" [title]="saveFilterTooptip">Save Filter</a>
    <a class="button discord" (click)="contactMe();" [title]="contactMeTooptip">Contact Me</a>
  </div>
  <div class="filtermessage" *ngIf="filteredTradeskills.length == MAX_TABLE_ENTRIES">
    <span style="color: orange;">Only the first {{MAX_TABLE_ENTRIES}} of {{tradeskills.length}}
      are entries displayed. Use the filters to search for specific entries.</span>
  </div>
  <div class="filtermessage" *ngIf="filteredTradeskills.length < MAX_TABLE_ENTRIES">
    <span>{{filteredTradeskills.length}} of {{tradeskills.length}} match the current filter.</span>
  </div>
  <!-- h1 style="color: red;">Website is currently undergoing maintenance. Upload functionality temporary disabled. Please try again in a few hours.</h1 -->
  <div class="table">
    <table>
      <colgroup>
        <col width="18%">
        <col width="18%">
        <col width="18%">
        <col width="18%">
        <col width="28%">
      </colgroup>
      <thead style="z-index: 33;">
      <tr>
        <th class="dark">
          <span *ngIf="orderColumn == 'server' && orderDirection == 1"
                (click)="orderBy('server')">&#x25BC; Realm ({{distinctServers}})</span>
          <span *ngIf="orderColumn == 'server' && orderDirection == -1"
                (click)="orderBy('server')">&#x25B2; Realm ({{distinctServers}})</span>
          <span *ngIf="orderColumn != 'server'" (click)="orderBy('server')">Realm ({{distinctServers}})</span>
          <br/>
          <input class="filter" type="text" placeholder="Filter By Realm" [(ngModel)]="serverFilter"
                 (ngModelChange)="filter()">
        </th>
        <th class="dark">
          <span *ngIf="orderColumn == 'guild' && orderDirection == 1"
                (click)="orderBy('guild')">&#x25BC; Guild ({{distinctGuilds}})</span>
          <span *ngIf="orderColumn == 'guild' && orderDirection == -1"
                (click)="orderBy('guild')">&#x25B2; Guild ({{distinctGuilds}})</span>
          <span *ngIf="orderColumn != 'guild'" (click)="orderBy('guild')">Guild ({{distinctGuilds}})</span>
          <br/>
          <input class="filter" type="text" placeholder="Filter By Guild" [(ngModel)]="guildFilter"
                 (ngModelChange)="filter()">
        </th>
        <th class="dark">
          <span *ngIf="orderColumn == 'character' && orderDirection == 1"
                (click)="orderBy('character')">&#x25BC; Character ({{distinctCharacters}})</span>
          <span *ngIf="orderColumn == 'character' && orderDirection == -1"
                (click)="orderBy('character')">&#x25B2; Character ({{distinctCharacters}})</span>
          <span *ngIf="orderColumn != 'character'" (click)="orderBy('character')">Character ({{distinctCharacters}})
          </span>
          <br/>
          <input class="filter" type="text" placeholder="Filter By Character" [(ngModel)]="characterFilter"
                 (ngModelChange)="filter()">
        </th>
        <th class="dark">
          <span *ngIf="orderColumn == 'tradeskill' && orderDirection == 1"
                (click)="orderBy('tradeskill')">&#x25BC; Tradeskill ({{distinctTradeskills}})</span>
          <span *ngIf="orderColumn == 'tradeskill' && orderDirection == -1"
                (click)="orderBy('tradeskill')">&#x25B2; Tradeskill ({{distinctTradeskills}})</span>
          <span *ngIf="orderColumn != 'tradeskill'" (click)="orderBy('tradeskill')">Tradeskill ({{distinctTradeskills}})
          </span>
          <br/>
          <input class="filter" type="text" placeholder="Filter By Tradeskill" [(ngModel)]="tradeskillFilter"
                 (ngModelChange)="filter()">
        </th>
        <th class="dark">
          <span *ngIf="orderColumn == 'recipe' && orderDirection == 1"
                (click)="orderBy('recipe')">&#x25BC; Recipe ({{distinctRecipies}})</span>
          <span *ngIf="orderColumn == 'recipe' && orderDirection == -1"
                (click)="orderBy('recipe')">&#x25B2; Recipe ({{distinctRecipies}})</span>
          <span *ngIf="orderColumn != 'recipe'" (click)="orderBy('recipe')">Recipe ({{distinctRecipies}})</span>
          <br/>
          <input class="filter" type="text" placeholder="Filter By Recipe" [(ngModel)]="recipeFilter"
                 (ngModelChange)="filter()" autofocus >
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor='let tradeskill of filteredTradeskills'>
        <td>{{tradeskill.server}}</td>
        <td>{{tradeskill.guild}}</td>
        <td>{{tradeskill.character}}</td>
        <td>{{tradeskill.tradeskill}}</td>
        <td>
          <a *ngIf="version === 'classic'" target="_blank" href="https://classic.wowhead.com/{{tradeskill.spellId}}" [attr.data-wowhead]="tradeskill.spellId"></a>
          <a *ngIf="version === 'tbc'" target="_blank" href="https://tbc.wowhead.com/{{tradeskill.spellId}}" [attr.data-wowhead]="tradeskill.spellId"></a>
          <a *ngIf="version === 'wotlk'" target="_blank" href="https://www.wowhead.com/wotlk/{{tradeskill.spellId}}" [attr.data-wowhead]="tradeskill.spellId"></a>
        </td>
      </tbody>
    </table>
  </div>
</div>
